export default __webpack_public_path__ + "static/media/expl_05_EN.75324de2.png";